import { Component, Input } from '@angular/core';

import { IconComponent } from '@atoms/icon/icon.component';
import { ImageComponent } from '@atoms/image/image.component';
import { SliderItemComponent } from '@molecules/slider/slider-item/slider-item.component';
import { PhonePipe } from '@pipes/phone.pipe';

@Component({
  selector: 'app-contact-cards-slider-item',
  imports: [IconComponent, ImageComponent, SliderItemComponent, PhonePipe],
  templateUrl: './contact-cards-slider-item.component.html',
  styleUrl: './contact-cards-slider-item.component.scss',
})
export class ContactCardsSliderItemComponent {
  @Input() photo?: string;
  @Input() name?: string;
  @Input() position?: string;
  @Input() phone?: string;
  @Input() email?: string;
}
